import { useState } from 'react'
import { BillF, DepositF, ReservationF, ReservationHeaderTab } from './types/reservation-detail.types'
import { reservationPagesPermissions, HicReservationPages } from 'src/app/components/authorization/pages-permissions'
import { useGrant } from 'src/app/components/authorization/grant-hooks'
import { HICLoading } from 'hic-components'
import { ReservationDetailData } from './reservation-detail-data'

type ReservationDetailProps = {
  propertyId: string
  defaultReservedResourceId?: string
  refetchReservation: () => void
  queryLoading: boolean
  onCancel: () => void
  defaultTabIndex?: ReservationHeaderTab
  queryData:
    | {
        reservation: ReservationF
        bills: BillF[]
        deposits: DepositF[]
        reservationLink: string | null
      }
    | undefined
  unsavedChanges: (rrWithUnsavedChange?: string) => void
}

export function ReservationDetail({ queryLoading, queryData, ...props }: ReservationDetailProps) {
  const [loading, setLoading] = useState(false)
  const { isGranted } = useGrant()

  const editPermissions = reservationPagesPermissions.get(HicReservationPages.DATAILS_EDIT)
  const readOnly = !isGranted({ modules: editPermissions?.modules, permissions: editPermissions?.permissions, features: editPermissions?.features })

  return (
    <>
      {(loading || queryLoading) && <HICLoading />}
      {queryData != undefined && ( //
        <ReservationDetailData //
          {...props}
          readOnly={readOnly}
          setLoading={setLoading}
          reservation={queryData.reservation}
          bills={queryData.bills}
          deposits={queryData.deposits}
          reservationLink={queryData.reservationLink}
          onCancel={props.onCancel}
          unsavedChanges={props.unsavedChanges}
        />
      )}
    </>
  )
}
